import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialZoomOut: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M23.62 20.57H22.1v1.52h-1.53v1.53h-3.04v1.52h3.04v1.52h1.53v1.53h1.52v1.52h1.52v1.53h4.58v-1.53h1.52v-4.57h-1.52v-1.52h-1.53v-1.53h-1.52v-1.52h-1.53v-3.05h-1.52Zm1.52 3.05h1.53v1.52h1.52v1.52h1.53v1.53h-1.53v-1.53h-1.52v-1.52h-1.53Zm0-13.72h1.53v7.62h-1.53Zm-1.52-3.05h1.52V9.9h-1.52ZM22.1 5.33h1.52v1.52H22.1Zm-1.53-1.52h1.53v1.52h-1.53ZM6.86 11.43h13.71V16H6.86Zm10.67-9.15h3.04v1.53h-3.04ZM9.91 25.14h7.62v1.52H9.91Zm0-24.38h7.62v1.52H9.91ZM6.86 23.62h3.05v1.52H6.86Zm0-21.34h3.05v1.53H6.86ZM5.34 22.09h1.52v1.53H5.34Zm0-18.28h1.52v1.52H5.34ZM3.81 20.57h1.53v1.52H3.81Zm0-15.24h1.53v1.52H3.81ZM2.29 17.52h1.52v3.05H2.29Zm0-10.67h1.52V9.9H2.29ZM.76 9.9h1.53v7.62H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialZoomOut
